<template>
    <div class="kanban-container" ref="kanban">

        <div class="prod-kanban-header">【{{ companyName }}】品质看板</div>

        <div class="quality-kanban-header" style="display:flex">
            <div>今日巡检：<span>{{ todayPatrolCount }}</span></div>
            <div>巡检正常：<span>{{ todayPatrolCount - todayAbnormalCount }}</span></div>
            <div>巡检异常：<span>{{ todayAbnormalCount }}</span></div>
        </div>

        <div style="overflow: auto;height: 68%;">
            <table class="q-kanban-table" style="width:1200px">
                <tr>
                    <td style="width: 15px;max-width: 15px;">巡检点</td>

                    <td style="width: 25px;max-width: 25px;">巡检时间</td>
                    <td style="width: 15px;max-width: 15px;">巡检人</td>
                    <td style="width: 10px;max-width: 10px;">巡果</td>

                    <td style="width: 25px;max-width: 25px;">巡检时间</td>
                    <td style="width: 15px;max-width: 15px;">巡检人</td>
                    <td style="width: 10px;max-width: 10px;">巡果</td>

                    <td style="width: 25px;max-width: 25px;">巡检时间</td>
                    <td style="width: 15px;max-width: 15px;">巡检人</td>
                    <td style="width: 10px;max-width: 10px;">巡果</td>

                    <td style="width: 25px;max-width: 25px;">巡检时间</td>
                    <td style="width: 15px;max-width: 15px;">巡检人</td>
                    <td style="width: 10px;max-width: 10px;">巡果</td>

                    <td style="width: 35px;max-width: 35px;">最近异常情况</td>
                </tr>

                <tr v-for="(item, index) in qualityKanbanList" :key="index">

                    <td>{{ item.patrolPointName }}</td>

                    <td>{{ item.createdTimeOne }}</td>
                    <td>{{ item.makerOne }}</td>
                    <td>{{ item.statusOne }}</td>

                    <td>{{ item.createdTimeTwo }}</td>
                    <td>{{ item.makerTwo }}</td>
                    <td>{{ item.statusTwo }}</td>

                    <td>{{ item.createdTimeThree }}</td>
                    <td>{{ item.makerThree }}</td>
                    <td>{{ item.statusThree }}</td>

                    <td>{{ item.createdTimeFour }}</td>
                    <td>{{ item.makerFour }}</td>
                    <td>{{ item.statusFour }}</td>

                    <td>{{ item.abnCondition }}</td>
                </tr>

            </table>

            <div style="height: 10px;"></div>
        </div>

        <div style="height: 10px;"></div>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount"
                layout="total, sizes,prev, pager, next" :total="total" @current-change="pageClick"
                :page-sizes="[10, 15, 20, 25]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <div style="height: 10px;"></div>

        <div style="position: absolute;right: 30px;bottom: 5px;">
            <i class="el-icon-full-screen" @click="fullScreen" style="color:orange"></i>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            companyName: '中国制造',

            todayPatrolCount: 0,
            todayAbnormalCount: 0,

            qualityKanbanList: [],

            index: 0,
            statusSearch: 0,

            pageIndex: 0,
            pageNum: 10,
            total: 0,
            pageCount: 0
        }
    },
    methods: {
        getInfo() {
            this.$axios({
                method: "post",
                url: "/shiro/patrol/record/getInfo",
                data: {
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.todayPatrolCount = data.data.todayPatrolCount
                this.todayAbnormalCount = data.data.todayAbnormalCount
            })
        },
        getAll() {

            const formData = new FormData()

            formData.append('companyId', this.companyId)

            formData.append('pageIndex', this.pageIndex)
            formData.append('pageNum', this.pageNum)

            this.$axios({
                method: "post",
                url: "/shiro/quality/kanban/getAll",
                data: formData,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" });
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                this.qualityKanbanList = data.data

                this.total = this.qualityKanbanList[0].total

                for (let i in this.qualityKanbanList) {
                    var pkbl = this.qualityKanbanList[i]

                    if (pkbl.createdTimeOne) {
                        pkbl.createdTimeOne = this.$moment(pkbl.createdTimeOne).format("MM-DD HH:mm")
                    }

                    if (pkbl.createdTimeTwo) {

                        pkbl.createdTimeTwo = this.$moment(pkbl.createdTimeTwo).format("MM-DD HH:mm")
                    }

                    if (pkbl.createdTimeThree) {
                        pkbl.createdTimeThree = this.$moment(pkbl.createdTimeThree).format("MM-DD HH:mm")
                    }

                    if (pkbl.createdTimeFour) {
                        pkbl.createdTimeFour = this.$moment(pkbl.createdTimeFour).format("MM-DD HH:mm")
                    }

                    pkbl.statusOne = pkbl.statusOne == null ? '' : pkbl.statusOne == 0 ? '异常' : '正常'

                    pkbl.statusTwo = pkbl.statusTwo == null ? '' : pkbl.statusTwo == 0 ? '异常' : '正常'

                    pkbl.statusThree = pkbl.statusThree == null ? '' : pkbl.statusThree == 0 ? '异常' : '正常'

                    pkbl.statusFour = pkbl.statusFour == null ? '' : pkbl.statusFour == 0 ? '异常' : '正常'

                }

            })
        },
        toFloat3(val) {
            // console.log('toFloat2')
            // console.log(val.toFixed(3))
            // console.log(val.toFixed(3) * 100)
            if (isNaN(val)) {
                val = 0
            }

            return parseFloat((val.toFixed(3) * 100).toFixed(10))
        },
        fullScreen() {
            // console.log('fullScreen')
            let element = this.$refs.kanban
            // console.log(element)

            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        },
        pageClick(currentPage) {
            this.purchaseKanbanList = []

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAll()
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pageNum = val

            this.getAll()
        }
    },
    mounted() {
        this.setDefaultPath('/qualityKanban')

        this.getInfo()

        this.getAll()

        this.$axios({
            method: "post",
            url: "/shiro/company/get",
            data: {
                id: this.companyId
            }, headers: {
                token: this.token
            }
        }).then(result => {
            this.companyName = result.data.data.companyName
        })

    }
}
</script>

<style>
.kanban-container {
    width: 100%;
    height: 735px;
    background-color: #06207D;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    position: relative;
}

.prod-kanban-header {
    font-size: 25px;
    font-weight: bolder;
    color: white;
    line-height: 100px;
}

.quality-kanban-header {
    background-color: lightblue;
    color: #06207D;
    /* margin: 5px; */
    font-size: 16px;
}

.quality-kanban-header>div {
    width: 33%;
    height: 70px;
    line-height: 70px;
}

.quality-kanban-header span {
    font-size: 30px;
}

.quality-kanban-header span:nth-child(3) {
    color: red;
}

.q-kanban-table {
    width: 556px;
    table-layout: fixed;
    border: 1px solid white;
    font-size: 15px;
    font-weight: bold;
    color: white;
    border-collapse: collapse;
}

.kanban-tr-odd {
    font-size: 11px;
    color: black;
    background-color: white;
}

.kanban-tr {
    font-size: 11px;
    color: black;
    background-color: greenyellow;
}

.q-kanban-table td {
    border: 1px solid white;
    padding: 5px;
}

.kanban-tr-odd td,
.kanban-tr td {
    border: 1px solid black;
}

div::-webkit-scrollbar {
    background: #6f5499;
    border-radius: 10px;
    width: 10px;
    height: 10px;
}

div::-webkit-scrollbar-thumb {
    background: orange;
    border-radius: 10px;

}

.el-pagination__total {
    color: pink;
}
</style>